// frontend/src/pages/admin/cre/CreUpdatesPage.jsx
import { useCreUpdates } from './hooks/useCreUpdates';
import RunNowButton from './components/RunNowButton';
import DeliberationCard from './components/DeliberationCard';
import ProposedUpdateDiff from './components/ProposedUpdateDiff';

export default function CreUpdatesPage() {
  const { proposals, delibs, loading, runNow, approve, reject } = useCreUpdates();

  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-base font-bold text-gray-800">Updates CRE TURPE</h1>
          <p className="text-[11px] text-gray-500">
            Délibérations détectées par l'agent + propositions de modifications à valider.
          </p>
        </div>
        <RunNowButton onClick={runNow} />
      </div>

      {loading && <div className="text-[11px] text-gray-500">Chargement…</div>}

      <section>
        <h2 className="text-sm font-semibold text-gray-700 mb-2">
          Propositions en attente ({proposals.length})
        </h2>
        {proposals.length === 0 ? (
          <div className="text-[11px] text-gray-400 italic">Aucune proposition en attente.</div>
        ) : (
          proposals.map((p) => (
            <ProposedUpdateDiff key={p.id} proposal={p} onApprove={approve} onReject={reject} />
          ))
        )}
      </section>

      <section>
        <h2 className="text-sm font-semibold text-gray-700 mb-2">
          Délibérations détectées ({delibs.length})
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {delibs.slice(0, 12).map((d) => <DeliberationCard key={d.id} delib={d} />)}
        </div>
      </section>
    </div>
  );
}
